import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule, TRANSLATIONS_FORMAT } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';

import { MessageService } from 'primeng/api';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './state/effects/app.effects';

import { UnkownRouteScreenComponent } from './screens/unkown-route-screen/unkown-route-screen.component';

import { FieldMatchValidatorDirective } from './directives/field-match-validator.directive';
import { ChallengeMatchDirective } from './directives/challenge-match.directive';

import { SharedModule } from './modules/shared/shared.module';
import { MessagesModule } from 'primeng/messages';
import { CardModule } from 'primeng/card';
import { APOModule } from './modules/apo/apo.module';
import { UserManagementModule } from './modules/user-management/user-management.module';
import { EditorModule } from 'primeng/editor';
import { CloudApiModule } from './modules/cloud-api/cloud-api.module';

import { ApiProviderService } from './services/api-provider.service';
import { ApiProviderProdService } from './services/api-provider-prod.service';
import { ApiProviderMockService } from './services/api-provider-mock.service';

import { publicUserReducer } from './state/reducers/public-user-account.reducer';
import { contactModelReducer } from './state/reducers/contact-model.reducer';
import { loggedinUserReducer } from './state/reducers/loggedin-user.reducer';

import { DialogModule } from 'primeng/dialog';
import { appSettingsReducer } from './state/reducers/app-settings.reducer';
import { AutoFocusDirectiveDirective } from './directives/auto-focus-directive.directive';
import { LocalizationService } from './modules/shared/services/localization.service';
import { AddressInfoService } from './modules/shared/services/address-info.service';
import { ContactInfoService } from './modules/shared/services/contact-info.service';
import { DropdownValueService } from './modules/shared/services/dropdown-value-service.service';
import { PageLayoutService } from './modules/shared/services/page-layout.service';
import { SettingService } from './modules/shared/services/setting.service';
import { SharedDataService } from './services/shared-data-service.service';
import { PasswordRequiredDirective } from './directives/password-required.directive';
import { PasswordRequirementValidators } from './validators/passwordRequirment.validator';
import { EncryptionService } from './modules/shared/services/encryption.service';

@NgModule({
  declarations: [
    AppComponent,
    FieldMatchValidatorDirective,
    UnkownRouteScreenComponent,
    ChallengeMatchDirective,
    AutoFocusDirectiveDirective,
    PasswordRequiredDirective,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CardModule,
    MessagesModule,
    HttpClientModule,
    StoreModule.forRoot({
      AppSettings: appSettingsReducer,
      LoggedInUser: loggedinUserReducer,
      PublicUserAccount: publicUserReducer,
      Contact: contactModelReducer
    }),
    EffectsModule.forRoot([AppEffects]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    SharedModule,
    APOModule,
    UserManagementModule,
    DialogModule,
    EditorModule,
    CloudApiModule
  ],
  providers: [
    {
      provide: ApiProviderService,
      useClass: environment.production
        ? ApiProviderProdService
        : ApiProviderMockService
    },
    { provide: LOCALE_ID, useValue: environment.defaultLanguage},
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf2' },
    MessageService,
    AddressInfoService,
    ContactInfoService,
    DropdownValueService,
    EncryptionService,
    PageLayoutService,
    LocalizationService,
    PasswordRequirementValidators,
    SettingService,
    SharedDataService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
